const URL = process.env.NEXT_PUBLIC_API_URL ||
    "https://image-nation.org/api-service";

export async function postData(endpoint: string, data: any) {
    try {
        const response = await fetch(URL + endpoint, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });

        const result = await response.json();

        if (!response.ok) {
            throw new Error(result.message || "An error occurred");
        }

        return result;
    } catch (error) {
        console.error("Error in postData:", error);
        throw error;
    }
}

export async function getData(endpoint: string) {
    try {
        const response = await fetch(URL + endpoint, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        const result = await response.json();

        if (!response.ok) {
            throw new Error(result.message || "An error occurred");
        }

        return result;
    } catch (error) {
        console.error("Error in getData:", error);
        throw error;
    }
}
